import React, { Component, Fragment } from 'react'
import Popup from './Popup'
import * as serviceWorker from '../serviceWorker'
import LOG from '../logging/Logger'

const updateMessage = 'A new version is available. Click here to update now.'

export default class ServiceWorkerUpdater extends Component {
  state = {
    newVersionAvailable: false,
    waitingWorker: null
  }

  componentDidMount() {
    serviceWorker.register({ onUpdate: this.onServiceWorkerUpdate })
  }

  onServiceWorkerUpdate = registration => {
    LOG.info('Detected new version available, notify user')
    this.setState({
      newVersionAvailable: true,
      waitingWorker: registration && registration.waiting
    })
  }

  updateServiceWorker = () => {
    LOG.info('Applying new version...')

    this.state.waitingWorker &&
      this.state.waitingWorker.postMessage({ type: 'SKIP_WAITING' })
    this.setState({
      newVersionAvailable: false
    })
    window.location.reload()
  }

  render() {
    LOG.debug('Render: ServiceWorkerUpdater')

    return (
      <Fragment>
        {this.props.children}
        <Popup
          open={this.state.newVersionAvailable}
          variant='info'
          onClick={this.updateServiceWorker}
          message={updateMessage}
          keepOpen={true}
        />
      </Fragment>
    )
  }
}
